import React, { useState, useEffect, useRef } from "react"
import PropTypes from "prop-types"

import "bootstrap-icons/font/bootstrap-icons.css"

function CloudflareStream(props) {
  const [readyToStream, setReadyToStream] = useState(false)
  const [streamMuted, setStreamMuted] = useState(false)

  const player = useRef(null)

  const toggleAudio = () => {
    player.current.muted = false
    setStreamMuted(!streamMuted)
  }

  useEffect(() => {
    if (window.Stream) return setReadyToStream(true)

    const script = document.createElement("script")
    script.src = "https://embed.videodelivery.net/embed/sdk.latest.js"
    script.onload = () => {
      setReadyToStream(true)
    }
    script.async = true
    document.body.appendChild(script)
    return () => {
      document.body.removeChild(script)
    }
  }, [])

  useEffect(() => {
    if (!readyToStream) return

    player.current = window.Stream(
      document.getElementById(`stream-player-${props.videoStreamId}`),
    )
    player.current.play().catch(() => {
      player.current.muted = true
      player.current.play()
      setStreamMuted(true)
    })
  }, [readyToStream, props.videoStreamId])

  if (!readyToStream) return <></>

  return (
    <div className={props.className} style={{ position: "relative", paddingTop: "56.25%" }}>
      <iframe
        src={`https://iframe.videodelivery.net/${props.videoStreamId}?&loop=true&controls=false`}
        style={{
          border: "none",
          position: "absolute",
          top: 0,
          left: 0,
          height: "100%",
          width: "100%",
        }}
        allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;"
        allowFullScreen={true}
        loop={true}
        title={`stream-player-${props.videoStreamId}`}
        id={`stream-player-${props.videoStreamId}`}
      ></iframe>
      {streamMuted && false && (
        <span
          style={{
            border: "none",
            position: "absolute",
            bottom: "20px",
            right: "20px",
          }}
        >
          <a
            href="!#"
            style={{
              color: "white",
              textDecoration: "none",
            }}
            onClick={evt => {
              evt.preventDefault()
              toggleAudio()
            }}
          >
            <i className={`bi bi-trophy-fill`}></i>
          </a>
        </span>
      )}
    </div>
  )
}

CloudflareStream.SOURCE_ID = "cdn"

CloudflareStream.propTypes = {
  videoStreamId: PropTypes.string.isRequired,
}

export default CloudflareStream
